<template>
    <div :class="['dimmer' , loading || form.loading ?  'active' : '']">
        <div class="loader"></div>
        <div class="dimmer-content">
            <form @submit.prevent="create" method="post">
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>First Name</label>
                            <input type="text" v-model="form.first_name"
                                   :class="[ 'form-control' , form.errors.get('first_name') ? 'is-invalid' : '' ]"
                                   placeholder="Enter first name">
                            <div v-text="form.errors.get('first_name')" class="invalid-feedback"/>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>Last Name</label>
                            <input type="text" v-model="form.last_name"
                                   :class="[ 'form-control' , form.errors.get('last_name') ? 'is-invalid' : '' ]"
                                   placeholder="Enter last name">
                            <div v-text="form.errors.get('last_name')" class="invalid-feedback"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>Email</label>
                            <input type="text" v-model="form.email"
                                   :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                                   placeholder="Enter email">
                            <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>Phone</label>
                            <input type="text" v-model="form.phone"
                                   :class="[ 'form-control' , form.errors.get('phone') ? 'is-invalid' : '' ]"
                                   placeholder="Enter phone">
                            <div v-text="form.errors.get('phone')" class="invalid-feedback"/>
                        </div>
                    </div>
                </div>

                <button @click.prevent="create"
                        :class="['btn btn-primary btn-block mt-2' ,  form.loading ? 'btn-loading' : '']"
                        type="submit">Save Changes
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import Form from "../../../core/forms/form";

export default {
    name: "Index",
    data() {
        return {
            loading: false,
            permissions: [],
            form: new Form({
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
            }, {}),
        };
    },

    mounted() {
        this.init();
    },

    methods: {
        init() {
            this.loading = true;
            window.axios.get(`/business/profile/api`).then((response) => {
                this.form.first_name = response.data.body.model.name;
                this.form.last_name = response.data.body.model.last_name;
                this.form.phone = response.data.body.model.phone;
                this.form.email = response.data.body.model.email;
                this.loading = false;
            });
        },
        create() {
            this.form.submit(`/business/profile/update`).then((response) => {
                this.init();
            }).catch((error) => {
            }).finally(() => {
            });
        }
    }
}
</script>

<style scoped>

</style>
